import { cn } from "../classnames.js";

const sharedCellStyles = [
  "tw-px-4",
  "tw-py-3",
  "@lg:first:tw-pl-6 supports-not-container-queries:md:first:tw-pl-6",
  "@lg:last:tw-pr-6 supports-not-container-queries:md:last:tw-pr-6",
  "empty:!tw-p-0 last:empty:!tw-pr-2 empty:tw-w-0",
  "tw-text-left",
];

export type TableHeadProps = {
  children?: React.ReactNode | undefined;
  className?: string | undefined;
  id?: string | undefined;
  key?: string | undefined;
};

export const TableHead = ({
  children,
  className,
  ...otherProps
}: TableHeadProps) => <thead {...otherProps}>{children}</thead>;

export type TableHeaderProps = {
  children?: React.ReactNode | undefined;
  className?: string | undefined;
  id?: string | undefined;
  key?: string | undefined;
};

export const TableHeader = ({
  children,
  className,
  ...otherProps
}: TableHeaderProps) => {
  return (
    <th
      scope="col"
      className={cn(...sharedCellStyles, "tw-text-muted", className)}
      {...otherProps}
    >
      {children}
    </th>
  );
};

export type TableRowProps = {
  children?: React.ReactNode | undefined;
  className?: string | undefined;
  id?: string | undefined;
  key?: string | undefined;
};

export const TableRow = ({
  children,
  className,
  ...otherProps
}: TableRowProps) => {
  return (
    <tr className={cn("even:tw-bg-bg", className)} {...otherProps}>
      {children}
    </tr>
  );
};

export type TableDataProps = {
  children?: React.ReactNode | undefined;
  className?: string | undefined;
  id?: string | undefined;
  key?: string | undefined;
};

export const TableData = ({
  children,
  className,
  ...otherProps
}: TableDataProps) => (
  <td
    className={cn(
      ...sharedCellStyles,
      "tw-tabular-nums",
      "tw-text-text",
      className,
    )}
    {...otherProps}
  >
    {children}
  </td>
);

export type TableBodyProps = {
  children?: React.ReactNode | undefined;
  className?: string | undefined;
  id?: string | undefined;
  key?: string | undefined;
};

export const TableBody = ({
  children,
  className,
  ...otherProps
}: TableHeaderProps) => <tbody {...otherProps}> {children} </tbody>;

export type TableProps = {
  children?: React.ReactNode | undefined;
  className?: string | undefined;
  id?: string | undefined;
  key?: string | undefined;
};

export const Table = ({ children, className, ...otherProps }: TableProps) => (
  <table
    className={cn(
      "tw-@container",
      "tw-w-full",
      "tw-border-collapse",
      "tw-transition-opacity",
      "tw-duration-200",
      className,
    )}
    {...otherProps}
  >
    {children}
  </table>
);
